<p-card header="Weryfikacja adresu e-mail" tabindex="0">
  <div class="flex justify-between">
    <div>
      @if (success()) {
        <div>
          <p>Twój adres e-mail został poprawnie zweryfikowany.</p>
        </div>
      } @else {
        <div>
          <p>
            Niestety nie udało się poprawnie zweryfikować Twojego adresu e-mail.
          </p>
        </div>
      }
    </div>
    <div>
      @if (success()) {
        <p-button
          label="Przejdź do strony głównej"
          styleClass="customInfoButton"
          (click)="navigateToMainPage()"
          size="small"
        />
      }
    </div>
  </div>
</p-card>
